function trackBuyTip(trigger, position, campaign) {
  if (window.dataLayer && typeof window.dataLayer.push === 'function') {
    window.dataLayer.push({
      event: 'ga-datalayer',
      eventCategory: trigger,
      eventAction: position,
      eventLabel: campaign,
    });
  }
}

/*
  Helper function to check if element is in viewport.
*/
function isInViewport(el) {
  if (!el) {
      return false;
  }
  const rect = el.getBoundingClientRect();
  return (
      (rect.top + rect.height) >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}

const trackedImpressionPositions = [];

/*
  Check if ad impression is in viewport and add it to array. Then send it to google analytics.
*/
function checkAdsInViewport() {
  const impressions = document.querySelectorAll('[data-trigger="impression"]');
  impressions.forEach(impression => {
    if ( !isInViewport(impression) ) {
      return;
    }
    const {trigger, position, campaign} = impression.dataset;
    
    if (trackedImpressionPositions.includes(position)) {
      return;
    }
    trackedImpressionPositions.push(position);
    trackBuyTip(trigger, position, campaign);
  });
}

/*
  Add event listener to all buytips and send click to google analytics.
*/
document.addEventListener('DOMContentLoaded', () => {
  const buytips = document.querySelectorAll('[data-trigger="click"]');

  buytips.forEach(buytip => {
    buytip.addEventListener('click', (e) => {
      const {trigger, position, campaign} = e.target.dataset;
      
      trackBuyTip(trigger, position, campaign)
    });
  });

  checkAdsInViewport();
    
});

/*
  Add event listener to scroll and check if ad impression is in viewport.
*/
document.addEventListener('scroll', () => {
  checkAdsInViewport();
}, { passive: true });
